module.exports = {
          srcSet: __webpack_public_path__ + "assets/3f70fc0c4159574ba6c662c78eccab5e.webp"+" 63w",
          images:[ {path: __webpack_public_path__ + "assets/3f70fc0c4159574ba6c662c78eccab5e.webp",width: 63,height: 63}],
          src: __webpack_public_path__ + "assets/3f70fc0c4159574ba6c662c78eccab5e.webp",
          toString:function(){return __webpack_public_path__ + "assets/3f70fc0c4159574ba6c662c78eccab5e.webp"},
          
          width: 63,
          height: 63
        }